/* Quality Guard — flashes a loud toast the instant a load is logged out of spec
   (added water over AS 1379, or actual W/C over the locked max). Mounted on the
   dispatch boards and the batcher cockpit. */
import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { WS_BASE } from "@/lib/api";
import { tone } from "@/lib/voice";

export default function SpecAlertWatcher() {
  const seen = useRef(new Set());

  useEffect(() => {
    let closed = false;
    let ws = null;
    let retry = 0;
    let timer = null;

    const announce = (evt) => {
      const key = `${evt.id || evt.docket_id}:${evt.created_at}`;
      if (seen.current.has(key)) return;
      seen.current.add(key);
      tone(880, 0.18, 0, 0.5);
      tone(560, 0.28, 0.2, 0.5);
      const who = evt.docket_no ? `Docket ${evt.docket_no}` : "A load";
      toast.error(`${who} is OUT OF SPEC`, {
        description: `${evt.mix_code || ""} · ${evt.customer_name || ""}${evt.truck_number ? ` · Truck ${evt.truck_number}` : ""}\n${(evt.reasons || []).join(" · ")}`,
        duration: 16000,
      });
    };

    const connect = () => {
      if (closed) return;
      try { ws = new WebSocket(`${WS_BASE}/ws/dispatch`); } catch { return; }
      ws.onmessage = (e) => {
        try {
          const evt = JSON.parse(e.data);
          if (evt.type === "docket.out_of_spec") announce(evt);
        } catch { /* ignore */ }
      };
      ws.onopen = () => { retry = 0; };
      ws.onclose = () => {
        if (closed) return;
        retry += 1;
        timer = setTimeout(connect, Math.min(15000, 1000 * 2 ** Math.min(retry, 4)));
      };
      ws.onerror = () => { try { ws.close(); } catch { /* ignore */ } };
    };
    connect();
    return () => { closed = true; clearTimeout(timer); try { ws && ws.close(); } catch { /* ignore */ } };
  }, []);

  return null;
}
